import type { ReactNode } from "react";
import React, { useEffect, useRef } from "react";

import { DarkTheme, LightTheme } from "./themes";

// TODO: should use the miu theme instead so that it matches rest of app

interface ThemeProps {
  variables: { [key: string]: string };
  children: ReactNode;
}

const Theme: React.FC<ThemeProps> = ({ variables, children }) => {
  const node = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateCSSVariables = () => {
      Object.entries(variables).forEach(([prop, value]) => {
        node.current?.style.setProperty(prop, value);
      });
    };

    updateCSSVariables();
  }, [variables]);

  return <div ref={node}>{children}</div>;
};

(Theme as any).Light = LightTheme;
(Theme as any).Dark = DarkTheme;

export default Theme;
